<span [class]="'text-xs font-bold rounded-full py-0.5 px-2 whitespace-nowrap ' + badgeClass()">
  {{ 'invoice-kind.' + kind() | translate }}
</span>
